type CheerConfig = {
    name: string; // Emote name, e.g., "Cheer", "Kappa"
    thresholds: number[]; // List of bit thresholds for this emote
    colorMap: Record<number, string>; // Map thresholds to colors
  };
  
  const cheerConfigs: CheerConfig[] = [
    {
      name: "Cheer",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "Kappa",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "SwiftRage",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "Kreygasm",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "4Head",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "PJSalt",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "MrDestructoid",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "TriHard",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "NotLikeThis",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "FailFish",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
    {
      name: "VoHiYo",
      thresholds: [1, 100, 1000, 5000, 10000],
      colorMap: {
        1: "gray",
        100: "purple",
        1000: "green",
        5000: "blue",
        10000: "red",
      },
    },
  ];
  
  /**
   * Get the URL for the cheer icon based on the name and bits value.
   */
  function getCheerIconUrl(
    name: string,
    bits: number,
    theme: "light" | "dark" = "dark", // Changed default theme to dark
    animated: boolean = true,
    size: number = 4
  ): string {
    const config = cheerConfigs.find((c) => c.name === name);
    if (!config) {
      throw new Error(`Unknown cheer name: ${name}`);
    }
  
    // Match the appropriate threshold and color
    const threshold = config.thresholds
      .slice()
      .reverse()
      .find((t) => bits >= t);
  
    if (!threshold) {
      throw new Error(`No valid threshold found for bits: ${bits}`);
    }
  
    const color = config.colorMap[threshold];
    const type = animated ? "animated" : "static";
  
    return `https://static-cdn.jtvnw.net/bits/${theme}/${type}/${color}/${size}`;
  }
  
  /**
   * Replace cheer keywords in text with corresponding image HTML tags.
   */
  export function replaceCheerTextWithIcons(
    text: string,
    theme: "light" | "dark" = "dark", // Changed default theme to dark
    animated: boolean = true,
    size: number = 4
  ): string {
    return text.replace(/(Cheer|SwiftRage|Kappa|Kreygasm|4Head|PJSalt|MrDestructoid|TriHard|NotLikeThis|FailFish|VoHiYo)(\d+)/g, (match, name, bitsStr) => {
      const bits = parseInt(bitsStr, 10);
      console.log(`Matched: ${name}, Bits: ${bitsStr}`); // Logging for debugging
  
      // Find the matching cheer config
      const config = cheerConfigs.find((c) => c.name === name);
      if (!config) {
        console.log(`Unknown cheer name: ${name}`);
        return match;
      }
  
      // Get the cheer icon URL
      const url = getCheerIconUrl(name, bits, theme, animated, size);
      return `<img src="${url}" alt="${match}" title="${match}" style="vertical-align:middle; margin:0 4px;">`;
    });
  }
